import React, { Component, useState,useEffect } from "react";

function Waitcursor (props) {



    return (
  <div id="wait" key="waitdiv1" className="tabcontent"  >  
<div align="center" key="waitdiv2" style={{"marginTop":"24px", "marginBottom":"24px"}} >
<img src="img/waitcircles.gif" border="0" style={{"height":"180px"}} />
<div key="waitdiv3" style={{"fontSize":"24px"}} > . . . please wait</div>
</div>
</div>);

}
export default Waitcursor; 